// https://github.com/diegomura/react-pdf/issues/1014#issuecomment-699650993

import { pdf } from "@react-pdf/renderer";
import { CircularProgress } from "@rmwc/circular-progress";
import "@rmwc/circular-progress/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./PDFViewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs`;
// // pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
// //   'pdfjs-dist/build/pdf.worker.min.mjs',
// //   import.meta.url,
// // ).toString();
// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher un PDF
 * @category PDFViewer
 */
function PDFViewer(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    children,
    pageWidth,
  } = props;

  // Initialisation du state
  const [pdfUrl, setPdfUrl] = useState(null);
  // #endregion

  // #region HOOK D'EFFET
useEffect(() => {
  if (!children) {
    setPdfUrl(null);
    return undefined;
  }

  const child = React.Children.only(children);
  let isMounted = true;
  let objectUrl = null;

  pdf(child).toBlob().then(blob => {
    if (!isMounted) {
      return;
    }

    objectUrl = URL.createObjectURL(blob);
    setPdfUrl(objectUrl);
  });

  return () => {
    isMounted = false;
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  };
}, [children]);
  // #endregion

  // #region INTERFACE
  // Affichant du composant de chargement
  const renderLoader = () => {
    return (
      <div className="PDFViewer-LoaderContainer">
        <CircularProgress
          size="xlarge"
          style={{ color: "#FAB001" }}
        />
      </div>
    )
  };

  // Attente du pdf avant de charger
  if (!pdfUrl) {
    return null;
  }

  // Interface
  return (
    <Document
      file={pdfUrl}
      loading={renderLoader()}
    >
      <Page
        pageNumber={1}
        renderMode="svg"
        {...(pageWidth != null ? { width: pageWidth } : {})}
      />
    </Document>
  )
  //#endregion
};
//#endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link PDFViewer}
 * @typedef {Object} PDFViewer.propTypes
 * @property {object} children JSX du document PDF à afficher
 * @property {number} [pageWidth] Largeur d'affichage de la page (px), transmise à react-pdf Page
*/
PDFViewer.propTypes = {
  children: PropTypes.object,
  pageWidth: PropTypes.number,
};

// Valeurs par défault des propriétés
PDFViewer.defaultProps = {
  children: null,
  pageWidth: undefined,
};
// #endregion

export { PDFViewer };

